import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import insuranceRouteList from "./routeList";


import PrivateRoute from "../Authentication/component/PrivateRoute";
import { base } from "../constants";
import moduleRoutes from "../routes/moduleRouteList";
import Loader from "../utilis/component/SkeletonLoading/Loader";

const VerificationPage = lazy(
  () => import("./Verification/components/VerificationPage")
);
const Verification = lazy(
  () => import("./Verification/components/Verification")
);
const SubmissionDetails = lazy(
  () => import("./ClaimListing/components/ViewClaimDownloads")
);
const ClaimListing = lazy(() => import("./ClaimListing"));
const ClaimProcesingComponent = lazy(
  () => import("./ClaimListing/components/ClaimProcesingComponent")
);
const RemittanceDashboard = lazy(() => import("./RemittanceDashboard"));
const VerificationDashboard = lazy(() => import("./Verification/index"));
const InsuranceDashboard = lazy(() => import("./Dashboard/index"));
const PriorApprovalDashboard = lazy(() => import("./PriorApprovalDashboard"));
const EmrLandingPage = lazy(() => import("../EMR/EmrLanding"));
const AuditLog = lazy(() => import("./AuditLog"));
const PatientClaimList = lazy(() => import("./PatientClaimList"));

const insuranceRoute: RouteObject[] = [
  {
    path: `${insuranceRouteList.auditlogLanding}`,
    element: (
      <PrivateRoute>
        <Loader>
          <EmrLandingPage
            path={`${base}${moduleRoutes.mainRoute}/insurance/audit-log/`}
          />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${insuranceRouteList.auditLog}/:encounterId/:patientId`,
    element: (
      <PrivateRoute>
        <Loader>
          <AuditLog />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: insuranceRouteList.insuranceDashboard,
    element: (
      <PrivateRoute>
        <Loader>
          <InsuranceDashboard />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${insuranceRouteList.Verification}`,
    element: (
      <PrivateRoute>
        <Loader>
          <Verification />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${insuranceRouteList.Verification}/:encounterId/:patientId`,
    element: (
      <PrivateRoute>
        <Loader>
          <VerificationDashboard />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: insuranceRouteList.claimListing,
    element: (
      <PrivateRoute>
        <Loader>
          <ClaimListing />
        </Loader>
      </PrivateRoute>
    ),
    children: [
      {
        path: `${insuranceRouteList.claimProcessing}/:id`,
        element: (
          <Loader>
            <ClaimProcesingComponent />
          </Loader>
        ),
      },
    ],
  },
  {
    path: insuranceRouteList.priorApprovalDashboard,
    element: (
      <PrivateRoute>
        <Loader variant="search-with-table">
          <PriorApprovalDashboard />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${insuranceRouteList.priorApprovalPatientEdit}/:encounterId?/:patientId?`,
    element: (
      <PrivateRoute>
        <Loader variant="search-with-table">
          <VerificationDashboard />
        </Loader>
      </PrivateRoute>
    ),
  },
  
  {
    path: insuranceRouteList.remittanceDashboard,
    element: (
      <PrivateRoute>
        <Loader>
          <RemittanceDashboard />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${insuranceRouteList.VerificationDetails}/:encounterId/:patientMasterID`,
    element: (
      <PrivateRoute>
        <VerificationPage />
      </PrivateRoute>
    ),
  },
  {
    path: `${insuranceRouteList.VerificationDetails}`,
    element: (
      <PrivateRoute>
        <VerificationPage />
      </PrivateRoute>
    ),
  },
  {
    path: `${insuranceRouteList.claimDownloadView}`,
    element: (
      <PrivateRoute>
        <SubmissionDetails />
      </PrivateRoute>
    ),
  },
  {
    path: insuranceRouteList.patientClaimList,
    element: (
      <PrivateRoute>
        <Loader>
          <PatientClaimList />
        </Loader>
      </PrivateRoute>
    ),
  },
];

// export default InsuranceRoute;
export default insuranceRoute;
